export interface HubNotification {
  id: string;
  title: string;
  message: string;
  severity: HubNotificationSeverity;
  source: string;
  createdAt: Date;
  expiredAt: Date;
  status: HubNotificationStatus;
  type?: string;
  link?: string;
}

export enum HubNotificationSeverity {
  LOW,
  MEDIUM,
  HIGH,
  CRITICAL,
}

export enum HubNotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
}
